const { asHTML } = require('@prismicio/helpers')

const filterPageAlerts = (alerts, node) => {
  return alerts.filter(alert => {
    const isSameLocale = alert.locale === node.lang
    const isExcludedPage = alert.data.exclude_pages.some(
      alert => alert.exclude_link?.uid === node.uid
    )
    const isAlertActive =
      (alert.data.display_on_every_page && !isExcludedPage) ||
      alert.data.display_on_pages.some(
        alertPage => alertPage.include_link.uid === node.uid
      )
    return isSameLocale && isAlertActive
  })
}

const htmlSerializer = pageLinks => {
  return {
    hyperlink: ({ children, node }) => {
      let url = ''
      let target = '_self'
      if (node.data.link_type === 'Web') {
        url = node.data.url
        if(node?.data?.target) {  
          target = node.data.target 
        }
        return `<a target=${target} href="${url}">${children}</a>`
      }
      if (pageLinks.length) {
        const pageLink = pageLinks.filter(pageNode => {
          return pageNode.pageuid === node.data.uid
        })
        url = pageLink[0].url
        return `<a href="${url}">${children}</a>`
      }
    },
    label: ({ children, node }) => {
      if (node.data.label === 'center-align')
        return `<center>${children}</center>`
    },
    //add future custom labels below
  }
}

const getSerializedHTML = (richTextRawValue, pageLinks = []) => {
  return asHTML(richTextRawValue, null, htmlSerializer(pageLinks))
}
  // Function to insert a hyperlink into text
  const insertLinkIntoText = (text, start, end, link) => {
    const linkText = text.substring(start, end);
    const hyperlink = `<a href="${link}">${linkText}</a>`;
    return text.slice(0, start) + hyperlink + text.slice(end);
  };

  // Function to find spans and insert the link
  const findSpansAndLinks = (paragraphs, pageLinks) => {
    return paragraphs.map(paragraph => {
      let { text, spans } = paragraph;
      let offset = 0;

      if (spans?.length) {
        spans.forEach(span => {
          const uid = span?.data?.uid;

          // If UID exists, find the matching link, else fallback to '#'
          const matchingLink = uid ? pageLinks.find(link => link.pageuid === uid) : null;
          const link = matchingLink ? matchingLink.url : '#'; // Default to '#' if no link is found
          
          if (link !== '#') { // Only insert link if it's valid
            const start = span.start + offset;
            const end = span.end + offset;
            text = insertLinkIntoText(text, start, end, link);
            offset += `<a href="${link}"></a>`.length;
          }
        });
      }
      return { ...paragraph, text };
    });
  };
  function wrapParagraph(content) {
    return `<p>${content.replace('</ul>', '</ul><p>').replace(/<\/p><p>\s*/g, ' ')}</p>`;
  }

const getBackgroundColor = (colorKey = 'White') => {
  const colorMap = {
    Blue: '#004FEF',
    'Brand Primary': '#004FEF',
    'Brand Secondary': '#3DDC97',
    Charcoal: '#1D1D1D',
    Green: '#3DDC97',
    'Light Gray': '#FCFCFC',
    'Medium Gray': '#F6F6F6',
    Purple: '#8363B6',
    White: '#FFFFFF',
  }

  return colorMap[colorKey] || colorMap['White']
}


const getTextHightlightBackgroundColor = (colorKey = '') => {
  const colorMap = {
    Blue: 'secondary',
    Green: 'alternate1',
    Purple: 'alternate2',
  }
  return colorMap[colorKey] || 'primary' 
}

module.exports = {
  filterPageAlerts,
  getSerializedHTML,
  getBackgroundColor,
  getTextHightlightBackgroundColor,
  findSpansAndLinks,
  wrapParagraph
}
